import React, {createContext, useEffect, useReducer} from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import useError from "../../hooks/useError";
import SessionOut from "../../views/sessions/SessionOut";

const initialValue = {
    banks: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_SELLER_DATA': {
            return {
                ...state,
                seller_bank: action.payload,
            }
        }
        case 'UPDATE_SELLER_DATA': {
            let newData = state.seller_bank.banks.map((seller) =>
                action.payload.id === seller.id ? action.payload : seller
            );

            let newState = {
                banks: newData
            }

            return {
                ...state,
                seller_bank: newState,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const SellerBankContext = createContext({
    seller_bank: initialValue,
    getSellerBanks: () => {},
    paySeller: () => {},
})

export const SellerBankProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)
    const { setError } = useError();


    const getSellerBanks = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sellers/get_seller_banks', options);

            dispatch({
                type: 'LOAD_SELLER_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const paySeller = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

           return await axios.post('/api/sellers/pay_seller', data, options);
        } catch (e) {
            if(e.response?.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response?.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})
            }else if(e.response?.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    useEffect(() => {
        getSellerBanks();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    if(state.status === 401){
        return <SessionOut />
    }

    if(state.seller_bank === undefined) {
        return <MatxLoading />
    }

    return (
        <SellerBankContext.Provider
            value={{
                seller_bank: state.seller_bank,
                getSellerBanks,
                paySeller,
            }}
        >
            {children}
        </SellerBankContext.Provider>
    )
}

export default SellerBankContext
